import { render } from "./petsProteenComponent.vue?vue&type=template&id=29205a84&scoped=true"
import script from "./petsProteenComponent.vue?vue&type=script&lang=js"
export * from "./petsProteenComponent.vue?vue&type=script&lang=js"

import "./petsProteenComponent.vue?vue&type=style&index=0&id=29205a84&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29205a84"]])

export default __exports__